export function parseStringToDate(
  date: string | undefined | null,
  defaultDate: Date,
): Date {
  if (date !== null && date !== undefined) {
    return new Date(Date.parse(date));
  }
  return defaultDate;
}
